import { createContext, useContext, useState } from 'react';

const BriefLiveWidgetContext = createContext();

const initialState = {
  selectedTab: 'talking-point',
};

const BriefLiveWidgetProvider = ({ children }) => {
  const [state, setState] = useState(initialState);

  const updateState = (payload) => setState((prev) => ({ ...prev, ...payload }));

  return <BriefLiveWidgetContext.Provider value={{ state, updateState }}>{children}</BriefLiveWidgetContext.Provider>;
};

export const useBriefLiveWidgetState = () => {
  return useContext(BriefLiveWidgetContext);
};

export default BriefLiveWidgetProvider;
